import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import './i18n';
import {SHORTEN_URL_PATH_PREFIX} from './constant';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

// 短網址只需要轉址，改載入獨立的輕量入口，避免先下載整包主程式造成切頁感
if (window.location.pathname.startsWith(SHORTEN_URL_PATH_PREFIX)) {
  import('./shortenUrlEntry').then(({default: renderShortenUrl}) =>
    renderShortenUrl(root),
  );
} else {
  import('./AppRoutes').then(({default: renderApp}) => renderApp(root));
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
